import { Injectable } from "@angular/core";
import { ForsyningIndstillingerService } from "@e-forsyning/common/forsyning-indstillinger";
import { BrugerHttpClient } from "@e-forsyning/common/http/bruger-http-client.service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class FeatureFlagService {
    constructor(
        private readonly forsyningIndstillingerService: ForsyningIndstillingerService,
        private readonly brugerHttp: BrugerHttpClient
    ) {}

    public getPilotKunde(): Observable<boolean> {
        const credentials = this.brugerHttp.credentials;
        const forsyningIndstillinger$ = this.forsyningIndstillingerService.hentForsyningIndstillinger(credentials.forsyningId);

        return forsyningIndstillinger$.pipe(
            map((indstillinger) => {
                if (!indstillinger) {
                    return false;
                }
                if (indstillinger.pilotKundeToggle === undefined || indstillinger.pilotKundeToggle === null || indstillinger.pilotKundeToggle === false) {
                    return false;
                }
                return indstillinger.pilotKundeToggle;
            })
        );
    }
}
